import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { useTabHandlerV2 } from '../../../hooks/useTabHandler';
import { ChartExample } from './tabs/Charts/ChartExample';
export const Slot1 = ({}) => {
    const tabsToDisplay = {
        Charts: (value) => _jsx(ChartExample, {}),
        // ... more tabs
    };
    const { tabs } = useTabHandlerV2({ tabsToDisplay, initialTabName: 'Charts', returnTabs: true });
    return (_jsxs("div", { children: [_jsx(Typography, { variant: 'h5', children: "Slot 1" }), tabs] }));
};
